"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetFavouriteAssessmentsCommand = void 0;
class SetFavouriteAssessmentsCommand {
    constructor(userId, studyId, assessments, expectedState, isLocal) {
        this.userId = userId;
        this.studyId = studyId;
        this.assessments = assessments;
        this.expectedState = expectedState;
        this.isLocal = isLocal;
    }
}
exports.SetFavouriteAssessmentsCommand = SetFavouriteAssessmentsCommand;
